import { Component, Inject, OnInit } from '@angular/core';
import { ComponentFlaggedVM } from '../../models/interpretation.model';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-view-flagged-component-info',
  templateUrl: './view-flagged-component-info.component.html',
  styleUrls: ['./view-flagged-component-info.component.scss']
})
export class ViewFlaggedComponentInfoComponent implements OnInit {


  InspectionDetailId:number;
  ComponentId:number;
  componentTypeId:number;

  FlaggedInfo:ComponentFlaggedVM;
  constructor(public dialogRef: MatDialogRef<ViewFlaggedComponentInfoComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _notify: NotificationsService,    private _interp: InterpretationService,) { }

  ngOnInit() {
    this.InspectionDetailId=this._data.InspectionDetailId
    this.ComponentId=this._data.ComponentId
    this.componentTypeId=this._data.componentTypeId
    this.FlaggedInfo=this._data.FlaggedInfo
  }
  onNoClick(){
    this.dialogRef.close(false);
  }

  UpdateComponentFlagged(){
        this._interp.UpdateComponentFlaggedInfo(this.FlaggedInfo).subscribe(r=>{
          if (r.m_Item1) {
            this._notify.success('Saved', r.m_Item2);
            this.dialogRef.close(true);
          } else {
            this._notify.error('Failed', r.m_Item2, r.m_Item2);
            this.dialogRef.close(false);

          }
        }, err => {
          this._notify.error('Failed', 'Unable to update flagged component. Please contact TrackTreads support. ', err);
        });

  }

}
